import React, { Component } from "react";
import {
  alert,
  GET,
  POST,
  PUT,
  DELETE,
  loading,
  required,
  Pagination,
  NavbarSuperUser,
  Modal,
  t,
  float,
  format_date,
} from "../../components/CustomComponent.js";

export default class CompanyManagement extends Component {
  constructor(props) {
    super(props);
    this.fileInputRef = React.createRef(); // สร้าง Ref สำหรับ input file โลโก้

    this.state = {
      modal_create: false,
      modal_update: false,
      modal_view: false,

      filter_search: "",
      filter_status: "",
      filter_portal: "",

      data: [],
      count: 10,

      // Dashboard Stats
      stats: {
        total: 12,
        active: 10,
        inactive: 2,
        users: 156,
        near_limit: 3,
        new_month: 2,
      },

      // Form Fields
      uid: "",
      company_code: "",
      company_name: "",
      company_name_en: "",
      description: "",
      email: "",
      phone: "",
      tax_number: "",
      
      // Address Fields
      address: "",
      province: "",
      district: "",
      sub_district: "",
      zip_code: "",
      
      // System Settings & Status
      asset_running_format: "",
      invoice_running_format: "",
      remark: "",
      logo: "", // Base64 สำหรับโลโก้
      isDragging: false, // สถานะ Drag & Drop
      is_active: "Active",
      
      // Admin Setup
      admin_name: "",
      admin_email: "",
      
      module_access: [],
      maximum_users: [],
      company: null,
    };
  }

  async componentDidMount() {
    loading(false);
    await this.Get(1);
  }

  Get = async (page) => {
    const { filter_search } = this.state;
    let data, count;
    loading(true);

    let result = await GET("company/info", {
      page_size: 10,
      page: page,
      data_search: filter_search,
    }, false);

    if (result?.status) {
      data = result.data;
      count = result.pagination?.count || 0;
    }

    this.setState({ data, count });
    loading(false);
  };

  // ฟังก์ชันสำหรับจัดการและ Resize รูปภาพ
  processImage = (file) => {
    if (!file) return;

    const validTypes = ['image/jpeg', 'image/png', 'image/jpg'];
    if (!validTypes.includes(file.type)) {
      alert("", "warning", t("warning"), "กรุณาอัพโหลดไฟล์ PNG หรือ JPG เท่านั้น");
      return;
    }

    if (file.size > 2 * 1024 * 1024) {
      alert("", "warning", t("warning"), "ขนาดไฟล์ต้องไม่เกิน 2MB");
      return;
    }

    const reader = new FileReader();
    reader.onload = (e) => {
      const img = new Image();
      img.onload = () => {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
        
        // กำหนดขนาด Resize 720x720
        const MAX_SIZE = 720;
        canvas.width = MAX_SIZE;
        canvas.height = MAX_SIZE;

        // คำนวณอัตราส่วนเพื่อ Crop กึ่งกลาง (1:1) ให้ภาพไม่เบี้ยว
        const size = Math.min(img.width, img.height);
        const x = (img.width - size) / 2;
        const y = (img.height - size) / 2;

        // วาดรูปลง Canvas
        ctx.clearRect(0, 0, MAX_SIZE, MAX_SIZE);
        ctx.drawImage(img, x, y, size, size, 0, 0, MAX_SIZE, MAX_SIZE);

        // แปลงเป็น Base64
        const base64String = canvas.toDataURL(file.type === "image/png" ? "image/png" : "image/jpeg", 0.9);
        this.setState({ logo: base64String });
      };
      img.src = e.target.result;
    };
    reader.readAsDataURL(file);
  };

  CreateUpdate = async () => {
    const {
      uid,
      company_name,
      company_name_en,
      description,
      address,
      province,
      district,
      sub_district,
      zip_code,
      email,
      phone,
      tax_number,
      is_active,
      admin_name,
      admin_email,
      module_access,
      maximum_users,
      asset_running_format,
      invoice_running_format,
      remark,
      logo
    } = this.state;

    if (!company_name.trim()) {
      alert("", "warning", t("warning"), t("verify_company_name"));
      return;
    } else if (!email.trim()) {
      alert("", "warning", t("warning"), t("verify_contact_email"));
      return;
    } else if (!asset_running_format.trim()) {
      alert("", "warning", t("warning"), t("verify_asset_running_format"));
      return;
    } else if (!invoice_running_format.trim()) {
      alert("", "warning", t("warning"), t("verify_invoice_running_format"));
      return;
    }

    if (
      await alert(
        "",
        "info",
        t("confirm"),
        t("confirm_submission"),
        t("confirm"),
        t("cancel"),
      )
    ) {
      loading(true);
      
      let body = {
        company_name,
        company_name_en,
        description,
        email,
        phone,
        tax_number : tax_number || "0",
        module_access: module_access.sort(), 
        maximum_users: maximum_users
          .sort((a, b) => a.user_type.localeCompare(b.user_type))
          .map((e) => ({
            ...e,
            maximum_users: Number(e.maximum_users),
          })),
        license_type: "standard",
        expire_date: "2027-04-01", 
        
        asset_running_format,
        invoice_running_format,
        logo,
        address,
        province,
        district,
        sub_district,
        zip_code,
        remark,
        
        role_id: "67756a58-22c2-4ecf-b0a3-1116f18aa307",
        admin_name,
        admin_email,
        is_active: is_active === "Active" ? true : false,
      };

      let result = !uid
        ? await POST("company/info", body, false)
        : await PUT("company/info/" + uid, body, false);

      if (result?.status === true) {
        alert("#", "success");
        this.setState({ modal_create: false, modal_update: false });
        this.Get(1);
      } else {
        alert(
          "",
          "warning",
          t("warning"),
          result?.message || "An error occurred.",
        );
      }
      loading(false);
    }
  };

  Delete = async (id) => {
    if (
      await alert(
        "",
        "warning",
        t("delete_item"),
        t("delete_desc"),
        t("confirm"),
        t("cancel"),
      )
    ) {
      loading(true);
      let result = await DELETE("company/info/" + id, null, false);
      if (result?.status) {
        alert("#", "success");
        this.Get(1);
      }
      loading(false);
    }
  };

  renderPortalIcons = (portals) => {
    return (
      <div className="d-flex gap-1 align-items-center">
        <div
          className="rounded d-flex justify-content-center align-items-center"
          style={{ width: 28, height: 28, backgroundColor: portals?.includes("admin-module") ? "#d6e4f9" : "#f1f3f5", color: portals?.includes("admin-module") ? "#1860c3" : "#dee2e6" }}
        >
          <span className="icon">{"\uf505"}</span>
        </div>
        <div
          className="rounded d-flex justify-content-center align-items-center"
          style={{ width: 28, height: 28, backgroundColor: portals?.includes("customer-module") ? "#d1f2e0" : "#f1f3f5", color: portals?.includes("customer-module") ? "#198754" : "#dee2e6" }}
        >
          <span className="icon">{"\uf1ad"}</span>
        </div>
        <div
          className="rounded d-flex justify-content-center align-items-center"
          style={{ width: 28, height: 28, backgroundColor: portals?.includes("mobile-module") ? "#fee5d0" : "#f1f3f5", color: portals?.includes("mobile-module") ? "#fd7e14" : "#dee2e6" }}
        >
          <span className="icon">{"\uf3ce"}</span>
        </div>
        <div
          className="rounded d-flex justify-content-center align-items-center"
          style={{ width: 28, height: 28, backgroundColor: portals?.includes("warehouse-module") ? "#eadef7" : "#f1f3f5", color: portals?.includes("warehouse-module") ? "#6f42c1" : "#dee2e6" }}
        >
          <span className="icon">{"\uf494"}</span>
        </div>
      </div>
    );
  };

  render() {
    const {
      modal_create,
      modal_update,
      modal_view,
      filter_search,
      filter_portal,
      data,
      count,
      stats,
      // States
      company_name, company_name_en, description, address, province, district, sub_district, zip_code,
      email, phone, tax_number, is_active, admin_name, admin_email,
      module_access, maximum_users, asset_running_format, invoice_running_format, remark, logo, isDragging, company,
    } = this.state;

    return (
      <div className="w-100 min-vh-100 bg-light" style={{ backgroundColor: "#f8f9fa" }}>
        <NavbarSuperUser />

        <div className="body px-4 py-3">
          {/* Header */}
          <div className="d-flex justify-content-between align-items-center mb-4">
            <div>
              <h4 className="fw-bold mb-1">{t("company_management")}</h4>
              <div className="text-secondary small">
                {t("manage_companies_desc")}
              </div>
            </div>
            <div className="d-flex">
              <div className="input-group me-3" style={{ width: "250px" }}>
                <input type="text" className="form-control" placeholder={t("search_companies")} />
              </div>
              <button
                className="btn btn-primary px-3 shadow-sm"
                onClick={() =>
                  this.setState({
                    uid: "",
                    company_name: "",
                    company_name_en: "",
                    description: "",
                    address: "",
                    province: "",
                    district: "",
                    sub_district: "",
                    zip_code: "",
                    email: "",
                    phone: "",
                    tax_number: "",
                    asset_running_format: "",
                    invoice_running_format: "",
                    remark: "",
                    logo: "",
                    is_active: "Active",
                    admin_name: "",
                    admin_email: "",
                    module_access: [],
                    maximum_users: [],
                    modal_create: true,
                  })
                }
              >
                <span className="icon">{"\u002b"}</span> {t("add_company")}
              </button>
            </div>
          </div>

          {/* Table Section */}
          <div className="card border-0 rounded-4 shadow-sm">
            <div className="card-header bg-white border-bottom-0 pt-4 pb-2 px-4 d-flex justify-content-between align-items-center">
              <h6 className="fw-bold mb-0">
                <span className="icon me-2 text-primary">{"\uf03a"}</span>{" "}
                {t("company_list")}
              </h6>
            </div>

            <div className="card-body p-0">
              <div className="table-responsive">
                <table className="table table-hover align-middle mb-0">
                  <thead className="bg-light text-muted small">
                    <tr>
                      <th className="py-3">{t("col_company")}</th>
                      <th className="py-3">{t("col_contact")}</th>
                      <th className="py-3">{t("col_portal_access")}</th>
                      <th className="py-3">{t("col_users")}</th>
                      <th className="py-3">{t("col_status")}</th>
                      <th className="py-3 text-center">{t("col_actions")}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data?.map((item, index) => {
                      return (
                        <tr key={`comp-${index}`}>
                          <td>
                            <div className="d-flex align-items-center">
                              <div className="rounded bg-primary-light d-flex align-items-center justify-content-center me-3 overflow-hidden" style={{ width: 40, height: 40 }}>
                                {item.logo ? (
                                    <img src={item.logo} alt="logo" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                                ) : (
                                    <span className="icon text-primary">{"\uf1ad"}</span>
                                )}
                              </div>
                              <div>
                                <div className="fw-bold text-dark">{item.company_name}</div>
                                <div className="small text-muted">{item.company_name_en}</div>
                              </div>
                            </div>
                          </td>
                          <td>
                            <div className="small text-dark fw-bold">{item.email}</div>
                            <div className="small text-muted">{item.phone}</div>
                          </td>
                          <td>{this.renderPortalIcons(item.module_access)}</td>
                          <td>
                            {item.maximum_users?.map(portal =>(
                            <div className="d-flex align-items-center" key={portal.user_type}>
                              <div className="progress mt-1" style={{ height: "4px", width: "80px" }}>
                              <div
                                className={`progress-bar ${portal.maximum_users < portal.active_users ? "bg-danger" : ((portal.active_users/portal.maximum_users)*100) > 80 ? "bg-warning" : "bg-primary"}`}
                                style={{ width: `${Math.min(((portal.active_users/portal.maximum_users)*100), 100)}%` }}
                              ></div>
                            </div>
                             <small className="text-10 ms-2">{portal.active_users || 0} / {portal.maximum_users}</small>
                            </div>
                            ))}
                          </td>
                          <td>
                            <span className={`badge rounded-pill px-3 py-2 fw-normal ${item.is_active ? "bg-success-light text-success" : "bg-secondary-light text-secondary"}`}>
                              {item.is_active ? t("active") : t("inactive")}
                            </span>
                          </td>
                          <td className="text-center">
                            <div className="d-flex justify-content-center gap-2">
                              <button
                                className="btn btn-sm btn-light text-muted p-1" style={{ width: 30, height: 30 }}
                                onClick={() => this.setState({
                                    ...item,
                                    is_active: item.is_active ? "Active" : "Inactive",
                                    company: item,
                                    modal_view: true,
                                  })
                                }
                              >
                                <span className="icon">{"\uf06e"}</span>
                              </button>
                              <button
                                className="btn btn-sm btn-light text-muted p-1" style={{ width: 30, height: 30 }}
                                onClick={() => this.setState({ 
                                    ...item, 
                                    is_active: item.is_active ? "Active" : "Inactive", 
                                    modal_update: true 
                                  })
                                }
                              >
                                <span className="icon">{"\uf044"}</span>
                              </button>
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="card-footer bg-white border-top-0 py-3 px-4 d-flex justify-content-between align-items-center">
              <small className="text-muted">
                {t("showing")} 1-{data?.length} {t("of")} {count} {t("companies")}
              </small>
              <Pagination count={Math.ceil(count / 10) || 1} showFirstButton showLastButton onChange={(_, page) => this.Get(page)} />
            </div>
          </div>
        </div>

        {/* CREATE / UPDATE MODAL */}
        <Modal
          size="lg"
          show={modal_create || modal_update}
          onHide={() => this.setState({ modal_create: false, modal_update: false })}
          centered
        >
          <Modal.Header className="border-bottom" closeButton>
            <h5 className="fw-bold mb-0">
              {modal_create ? t("add_new_company") : t("update_company")}
            </h5>
          </Modal.Header>
          <Modal.Body className="p-4" >
            <div className="row g-3">
              
              {/* อัปโหลดโลโก้บริษัท (Drag & Drop) */}
              <div className="col-12 mb-2">
                <label className="form-label small fw-bold text-secondary mb-1">โลโก้บริษัท</label>
                <div
                  className={`rounded-3 p-4 text-center pointer transition-hover d-flex flex-column align-items-center justify-content-center`}
                  onDragOver={(e) => { e.preventDefault(); this.setState({ isDragging: true }); }}
                  onDragLeave={(e) => { e.preventDefault(); this.setState({ isDragging: false }); }}
                  onDrop={(e) => {
                    e.preventDefault();
                    this.setState({ isDragging: false });
                    if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
                      this.processImage(e.dataTransfer.files[0]);
                    }
                  }}
                  onClick={() => this.fileInputRef.current.click()}
                  style={{
                    border: isDragging ? '2px dashed #4f46e5' : '2px dashed #e2e8f0',
                    backgroundColor: isDragging ? '#f8faff' : '#ffffff',
                    minHeight: '120px'
                  }}
                >
                  <input
                    type="file"
                    ref={this.fileInputRef}
                    className="d-none"
                    accept="image/png, image/jpeg, image/jpg"
                    onChange={(e) => {
                      if (e.target.files && e.target.files.length > 0) {
                        this.processImage(e.target.files[0]);
                      }
                    }}
                  />
                  {logo ? (
                    <div className="position-relative d-inline-block">
                      <img src={logo} alt="Company Logo" style={{ width: '100px', height: '100px', objectFit: 'contain' }} className="rounded shadow-sm border bg-white" />
                      <button
                        type="button"
                        className="btn btn-sm btn-danger position-absolute top-0 start-100 translate-middle rounded-circle d-flex align-items-center justify-content-center shadow"
                        style={{ width: '24px', height: '24px', padding: 0 }}
                        onClick={(e) => {
                          e.stopPropagation();
                          this.setState({ logo: "" });
                          if(this.fileInputRef.current) this.fileInputRef.current.value = "";
                        }}
                      >
                        <span className="icon text-10">{"\uf00d"}</span>
                      </button>
                    </div>
                  ) : (
                    <div>
                      <div className="text-secondary fw-bold mb-1 d-flex align-items-center justify-content-center text-14">
                        <span className="icon me-2 text-dark text-16">{"\uf030"}</span> คลิกเพื่ออัพโหลดโลโก้
                      </div>
                      <div className="text-muted text-12">PNG, JPG ขนาดไม่เกิน 2MB</div>
                    </div>
                  )}
                </div>
              </div>

              {/* Basic Information */}
              <div className="col-md-6">
                <label className="form-label small fw-bold">{t("company_name_label")} (TH) {required}</label>
                <input
                  type="text" className="form-control" placeholder={t("enter_company_name")}
                  value={company_name} onChange={(e) => this.setState({ company_name: e.target.value })}
                />
              </div>
              <div className="col-md-6">
                <label className="form-label small fw-bold">{t("company_name_label")} (EN)</label>
                <input
                  type="text" className="form-control" placeholder="Company Name (EN)"
                  value={company_name_en} onChange={(e) => this.setState({ company_name_en: e.target.value })}
                />
              </div>

              <div className="col-md-6">
                <label className="form-label small fw-bold">{t("contact_email")} {required}</label>
                <input
                  type="email" className="form-control" placeholder={t("eg_email")}
                  value={email} onChange={(e) => this.setState({ email: e.target.value })}
                />
              </div>
              <div className="col-md-6">
                <label className="form-label small fw-bold">{t("phone_number")}</label>
                <input
                  type="text" className="form-control" placeholder={t("eg_phone")}
                  value={phone} maxLength={10}
                  onChange={(e) => {
                    if (!float(e.target.value)) return;
                    this.setState({ phone: e.target.value });
                  }}
                />
              </div>
              <div className="col-md-12">
                <label className="form-label small fw-bold">{t("tax_id")}</label>
                <input
                  type="text" className="form-control" placeholder={t("enter_tax_id")}
                  value={tax_number} maxLength={13}
                  onChange={(e) => {
                    if (!float(e.target.value)) return;
                    this.setState({ tax_number: e.target.value });
                  }}
                />
              </div>

              <div className="col-12">
                <label className="form-label small fw-bold">{t("description")}</label>
                <input
                  type="text" className="form-control" placeholder={t("desc_placeholder")}
                  value={description} onChange={(e) => this.setState({ description: e.target.value })}
                />
              </div>

              {/* Address Split Section */}
              <div className="col-12 mt-3">
                <label className="form-label small fw-bold">{t("address")}</label>
                <textarea
                  className="form-control" rows="2" placeholder={t("enter_address")}
                  value={address} onChange={(e) => this.setState({ address: e.target.value })}
                ></textarea>
              </div>
              <div className="col-md-6">
                 <label className="form-label small fw-bold">จังหวัด</label>
                 <input type="text" className="form-control" value={province} onChange={(e) => this.setState({ province: e.target.value })} />
              </div>
              <div className="col-md-6">
                 <label className="form-label small fw-bold">อำเภอ/เขต</label>
                 <input type="text" className="form-control" value={district} onChange={(e) => this.setState({ district: e.target.value })} />
              </div>
              <div className="col-md-6">
                 <label className="form-label small fw-bold">ตำบล/แขวง</label>
                 <input type="text" className="form-control" value={sub_district} onChange={(e) => this.setState({ sub_district: e.target.value })} />
              </div>
              <div className="col-md-6">
                 <label className="form-label small fw-bold">รหัสไปรษณีย์</label>
                 <input type="text" className="form-control" value={zip_code} onChange={(e) => this.setState({ zip_code: e.target.value })} />
              </div>

              {/* Portal Access */}
              <div className="col-12 mt-4 border-top pt-4">
                <h6 className="fw-bold mb-1 d-flex align-items-center">
                  <span className="icon text-primary me-2">{"\uf52b"}</span>{" "}
                  {t("portal_access_title")}
                </h6>
                <small className="text-muted d-block mb-3">{t("portal_access_desc")}</small>
                <div className="row g-3">
                  {[
                    { id: "admin-module", icon: "\uf505", color: "primary", title: "admin_portal", desc: "admin_portal_desc" },
                    { id: "customer-module", icon: "\uf1ad", color: "success", title: "customer_portal", desc: "customer_portal_desc" },
                    { id: "mobile-module", icon: "\uf3ce", color: "warning", title: "mobile_service", desc: "mobile_service_desc" },
                    { id: "warehouse-module", icon: "\uf494", color: "purple", title: "warehouse_portal", desc: "warehouse_portal_desc" },
                  ].map((mod) => {
                    const isActive = module_access.includes(mod.id);
                    const maxUserVal = maximum_users.find((e) => e.user_type === mod.id)?.maximum_users || "";
                    return (
                      <div className="col-md-6" key={mod.id}>
                        <div className={`card p-3 rounded-3 transition-hover h-100 ${isActive ? `border-${mod.color}` : "border"}`}>
                          <div
                            className="d-flex align-items-center cursor-pointer"
                            onClick={() => {
                              this.setState({
                                module_access: isActive ? module_access.filter((e) => e !== mod.id) : [...module_access, mod.id],
                                maximum_users: isActive ? maximum_users.filter((e) => e.user_type !== mod.id) : [...maximum_users, { user_type: mod.id, maximum_users: "" }],
                              });
                            }}
                          >
                            <input className="form-check-input me-3 mt-0 pointer-events-none" type="checkbox" checked={isActive} readOnly style={{ width: "22px", height: "22px" }} />
                            <div className={`bg-${mod.color}-light text-${mod.color} rounded-3 d-flex justify-content-center align-items-center me-3`} style={{ width: "45px", height: "45px", flexShrink: 0 }}>
                              <span className="icon">{mod.icon}</span>
                            </div>
                            <div className="flex-grow-1">
                              <div className="fw-bold text-dark mb-0">{t(mod.title)}</div>
                              <div className="text-muted" style={{ fontSize: "12px" }}>{t(mod.desc)}</div>
                            </div>
                          </div>
                          {isActive && (
                            <div className="mt-3 pt-2 border-top row g-2">
                              <div className="col-12">
                                <label className="small fw-bold text-dark mb-1">จำกัดผู้ใช้งาน *</label>
                                <input
                                  type="text" className="form-control form-control-sm text-end" min="1" value={maxUserVal}
                                  onChange={(e) => {
                                    if (e.target.value !== "" && typeof float === "function" && !float(e.target.value)) return;
                                    let _maximum_users = [...maximum_users];
                                    let _index = _maximum_users.findIndex((m) => m.user_type === mod.id);
                                    if (_index > -1) {
                                      _maximum_users[_index].maximum_users = e.target.value;
                                      this.setState({ maximum_users: _maximum_users });
                                    }
                                  }}
                                />
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>

              {/* Initial Admin User */}
              {modal_create && (
                <div className="col-12 mt-4 border-top pt-4">
                  <h6 className="fw-bold mb-3 d-flex align-items-center">
                    <span className="icon text-primary me-2">{"\uf505"}</span>{" "}
                    {t("initial_admin_user")}
                  </h6>
                  <div className="row g-3">
                    <div className="col-md-6">
                      <label className="form-label small fw-bold">{t("admin_name")} *</label>
                      <input
                        type="text" className="form-control" placeholder={t("enter_admin_name")}
                        value={admin_name || ""} onChange={(e) => this.setState({ admin_name: e.target.value })}
                      />
                      <small className="text-muted" style={{ fontSize: "11px" }}>
                        <span className="icon me-1">{"\uf05a"}</span> {t("admin_pass_desc")}
                      </small>
                    </div>
                    <div className="col-md-6">
                      <label className="form-label small fw-bold">{t("admin_email")} *</label>
                      <input
                        type="email" className="form-control" placeholder={t("eg_email")}
                        value={admin_email || ""} onChange={(e) => this.setState({ admin_email: e.target.value })}
                      />
                    </div>
                  </div>
                </div>
              )}

              {/* การตั้งค่าระบบ (System Settings) ตามภาพที่ 1 */}
              <div className="col-12 mt-4 border-top pt-4">
                <h6 className="fw-bold mb-3 d-flex align-items-center">
                  <span className="icon text-secondary me-2">{"\uf013"}</span>
                  การตั้งค่าระบบ
                </h6>
                <div className="row g-3">
                  <div className="col-md-6">
                    <label className="form-label small fw-bold text-secondary mb-1">รูปแบบ ASSET ID</label>
                    <input 
                      type="text" 
                      className="form-control fw-bold" 
                      style={{ backgroundColor: "#f8faff", borderColor: "#cddbfe", color: "#4f46e5" }}
                      value={asset_running_format} 
                      onChange={(e) => this.setState({ asset_running_format: e.target.value })} 
                    />
                    <small className="text-primary mt-1 d-block">
                      <span className="icon">{"\uf0c1"}</span> เช่น BPSB-CS-0841-690101
                    </small>
                  </div>
                  <div className="col-md-6">
                    <label className="form-label small fw-bold text-secondary mb-1">รูปแบบ INVOICE NO.</label>
                    <input 
                      type="text" 
                      className="form-control fw-bold" 
                      style={{ backgroundColor: "#f8faff", borderColor: "#cddbfe", color: "#4f46e5" }}
                      value={invoice_running_format} 
                      onChange={(e) => this.setState({ invoice_running_format: e.target.value })} 
                    />
                    <small className="text-primary mt-1 d-block">
                      <span className="icon">{"\uf0c1"}</span> เช่น BPSB-IVT-69010094
                    </small>
                  </div>
                  <div className="col-12 mt-3">
                    <label className="form-label small fw-bold text-secondary mb-1">หมายเหตุ</label>
                    <textarea 
                      className="form-control" 
                      rows="3" 
                      placeholder="หมายเหตุเพิ่มเติมเกี่ยวกับบริษัท..." 
                      value={remark} 
                      onChange={(e) => this.setState({ remark: e.target.value })}
                    ></textarea>
                  </div>
                  <div className="col-12 mt-3">
                    <div className="bg-primary-light px-3 pt-3 pb-2 rounded-4 text-primary" style={{borderLeft: "4px solid #3b82f6"}}>
                  <b>Rules:</b><br/>
                  <ul>
                    <li><b>{"{yyyy}"}</b> - ปี ค.ศ. 4 หลัก</li>
                    <li><b>{"{yy}"}</b> - ปี ค.ศ. 2 หลัก</li>
                    <li><b>{"{mm}"}</b> - เดือน</li>
                    <li><b>{"{dd}"}</b> - วัน</li>
                    <li><b>{"{running_4}"}</b> - เลข running 4 หลัก</li>
                    <li><b>{"{running_5}"}</b> - เลข running 5 หลัก</li>
                    <li><b>{"{running_6}"}</b> - เลข running 6 หลัก</li>
                  </ul>
                </div>
                  </div>
                </div>
              </div>

              {/* สถานะ (Status) ตามภาพที่ 2 */}
              <div className="col-12 mt-4 border-top pt-4">
                <h6 className="fw-bold mb-3 d-flex align-items-center">
                  <span className="icon text-primary me-2" style={{ fontSize: "1.2rem" }}>{"\uf109"}</span>
                  สถานะ
                </h6>
                <div className="d-flex gap-4">
                  <div className="form-check d-flex align-items-center gap-2">
                    <input 
                      className="form-check-input mt-0 pointer" 
                      type="radio" 
                      name="companyStatus" 
                      id="statusActive"
                      checked={is_active === "Active"}
                      onChange={() => this.setState({ is_active: "Active" })}
                      style={{ width: "22px", height: "22px" }}
                    />
                    <label className="form-check-label text-dark mt-1 pointer" htmlFor="statusActive">
                      เปิดใช้งาน
                    </label>
                  </div>
                  <div className="form-check d-flex align-items-center gap-2">
                    <input 
                      className="form-check-input mt-0 pointer" 
                      type="radio" 
                      name="companyStatus" 
                      id="statusInactive"
                      checked={is_active === "Inactive"}
                      onChange={() => this.setState({ is_active: "Inactive" })}
                      style={{ width: "22px", height: "22px" }}
                    />
                    <label className="form-check-label text-dark mt-1 pointer" htmlFor="statusInactive">
                      ปิดใช้งาน
                    </label>
                  </div>
                </div>
              </div>

            </div>
          </Modal.Body>
          <Modal.Footer className="border-top p-3 bg-white d-flex justify-content-end">
            <button className="btn btn-outline-secondary px-4 me-2 bg-white" onClick={() => this.setState({ modal_create: false, modal_update: false })}>
              {t("cancel")}
            </button>
            <button className="btn btn-primary px-4 d-flex align-items-center" onClick={this.CreateUpdate} style={{ backgroundColor: "#2563eb", borderColor: "#2563eb" }}>
              <span className="icon me-2">{"\uf0c7"}</span> {t("save_company")}
            </button>
          </Modal.Footer>
        </Modal>

        {/* VIEW MODAL (ยังคงเดิม) */}
        <Modal
          size="lg"
          show={modal_view}
          onHide={() => this.setState({ modal_view: false })}
          centered
        >
          <Modal.Header className="border-bottom" closeButton>
            <h5 className="fw-bold mb-0">{t("company_details")}</h5>
          </Modal.Header>
          <Modal.Body className="p-4">
            <div className="d-flex align-items-center mb-4">
              <div className="rounded-3 d-flex justify-content-center align-items-center me-3 overflow-hidden" style={{ width: "60px", height: "60px", backgroundColor: "#e0edff" }}>
                {company?.logo ? (
                  <img src={company.logo} alt="logo" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                ) : (
                  <span className="icon text-primary">{"\uf1ad"}</span>
                )}
              </div>
              <div>
                <h5 className="fw-bold mb-1">{company?.company_name}</h5>
                <div className="d-flex align-items-center">
                  <span className="badge bg-light text-dark me-2">{company?.company_code}</span>
                  {company?.is_active ? (
                    <span className="badge bg-success-light text-success px-3">{t("active")}</span>
                  ) : (
                    <span className="badge bg-danger-light text-danger px-3">{t("inactive")}</span>
                  )}
                </div>
              </div>
            </div>
            <div className="row g-3">
              <div className="col-md-6">
                <div className="p-3 bg-light rounded-3">
                  <div className="small text-muted">{t("contact_email")}</div>
                  <div className="fw-bold">{company?.email}</div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="p-3 bg-light rounded-3">
                  <div className="small text-muted">{t("phone_number")}</div>
                  <div className="fw-bold">{company?.phone || "-"}</div>
                </div>
              </div>
              <div className="col-12">
                <div className="p-3 bg-light rounded-3">
                  <div className="small text-muted">{t("address")}</div>
                  <div className="fw-bold">
                    {company?.address || "-"} {company?.sub_district} {company?.district} {company?.province} {company?.zip_code}
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="p-3 bg-light rounded-3">
                  <div className="small text-muted">{t("total_users")}</div>
                  <div className="row">
                     {company?.maximum_users?.map(portal=>(
                        <div className="col-12 col-md-6 d-flex align-items-center" key={portal.user_type}>
                          <div>{t(portal.user_type)}</div>
                          <div className="fw-bold ms-2">{portal.active_users || 0} / {portal.maximum_users}</div>
                        </div>
                     ))}
                  </div>
                </div>
              </div>
              <div className="col-md-6" style={{minHeight: "100%"}}>
                <div className="p-3 bg-light rounded-3" style={{minHeight: "100%"}}>
                  <div className="small text-muted">{t("created_date")}</div>
                  <div className="fw-bold">{company?.created_at ? format_date(company?.created_at, "dd-mm-yyyy hh:mm", "th") : "-"}</div>
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer className="border-top bg-white p-3 d-flex justify-content-end">
            <button className="btn btn-outline-secondary px-4 me-2" onClick={() => this.setState({ modal_view: false })}>
              {t("close")}
            </button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}